(function () {
    'use strict';
    angular.module('emarket.store').directive('emStoreProductList', function () {
        return {
            scope: {
                title: '=',
                products: '='
            },
            templateUrl: 'store/store-product-list/store-product-list.tpl.html'
        }; 
    });
}());
